import { render, staticRenderFns } from "./FacultyAndDepartmentSelector.vue?vue&type=template&id=406aaa49&"
import script from "./FacultyAndDepartmentSelector.vue?vue&type=script&lang=js&"
export * from "./FacultyAndDepartmentSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports